import gql from 'graphql-tag';

const addUsersToTeamMutation = gql`
  mutation addUsersToTeam(
    $tid: String!
    $uids: [String]
  ) {
    addUsersToTeam(
      tid: $tid
      uids: $uids
    ) {
      _id
      name
      users {
        _id
        firstName
        lastName
      }
    }
  }
`;

export default addUsersToTeamMutation;